module.exports = __webpack_public_path__ + "static/img/team1.8b34c91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team1.jpg
// module id = NQE5
// module chunks = 1